import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrong-question-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "student-badge" }
const _hoisted_5 = { class: "filter-panel" }
const _hoisted_6 = {
  key: 0,
  class: "recommend-panel"
}
const _hoisted_7 = { class: "result-panel" }
const _hoisted_8 = { class: "result-head" }
const _hoisted_9 = { class: "result-head-left" }
const _hoisted_10 = {
  key: 1,
  class: "question-list"
}
const _hoisted_11 = { class: "question-main" }
const _hoisted_12 = { class: "question-main-content" }
const _hoisted_13 = { class: "question-title" }
const _hoisted_14 = { class: "metric-row" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "tag-row"
}
const _hoisted_17 = { class: "content-grid" }
const _hoisted_18 = { class: "media-box" }
const _hoisted_19 = { class: "box-title box-title-row" }
const _hoisted_20 = {
  key: 0,
  class: "image-row"
}
const _hoisted_21 = ["src", "onClick"]
const _hoisted_22 = { class: "analysis-box" }
const _hoisted_23 = {
  key: 0,
  class: "analysis-body"
}
const _hoisted_24 = {
  key: 0,
  class: "analysis-text"
}
const _hoisted_25 = {
  key: 1,
  class: "image-row"
}
const _hoisted_26 = { class: "answer-row" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "pagination-wrap" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = {
  class: "hidden-preview-group",
  "aria-hidden": "true"
}

import { computed, nextTick, onBeforeUnmount, onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import router from "@/router";
import { useUserStore } from "@/store";
import {
  getStudentWrongQuestionRecommend as getStudentWrongQuestionRecommendApi,
  getStudentWrongQuestionSearch as searchStudentWrongQuestionApi,
  putStudentWrongQuestionReview,
} from "@/servers/api/wrongQuestion";
import { postCartList } from "@/servers/api/cart";
import { useWrongQuestionCart } from "@/composables/useWrongQuestionCart";
import WrongQuestionCartDrawer from "./components/WrongQuestionCartDrawer.vue";

type CountItem = { name: string; count: number };
type Option = { label: string; value: string };
type WrongQuestionRecord = {
  [key: string]: unknown;
  exam_id?: number | string;
  exam_name?: string;
  test_paper_id?: number | string;
  question_key?: string;
  string_number?: string;
  subject?: string;
  question_type?: string;
  knowledge_points?: string[] | string;
  images?: string[] | string;
  answer?: string;
  analysis?: string;
  student_score?: number | string;
  full_score?: number | string;
  class_id?: string;
  question_id?: number | string;
  is_reviewed?: boolean;
  year?: string;
};

const transparentImage =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";

export default /*@__PURE__*/_defineComponent({
  __name: 'StudentWrongQuestion',
  setup(__props) {

const userStore = useUserStore();
const { cartCount, incrementCount, fetchCartCount } = useWrongQuestionCart();
const rows = ref<WrongQuestionRecord[]>([]);
const selectedQuestionKeys = ref<Set<string>>(new Set());
const addingToCart = ref(false);
const cartDrawerOpen = ref(false);
const loading = ref(false);
const recommendLoading = ref(false);
const recommendKnowledge = ref<CountItem[]>([]);
const recommendTypes = ref<CountItem[]>([]);
const questionTypeOptions = ref<Option[]>([]);
const studentUid = ref("");
const studentName = ref("");
const reviewUpdatingKey = ref("");
const questionPreview = reactive<{ open: boolean; current: number; record: WrongQuestionRecord | null }>({
  open: false,
  current: 0,
  record: null,
});
const analysisViewer = reactive<{ open: boolean; record: WrongQuestionRecord | null }>({
  open: false,
  record: null,
});
const analysisPreview = reactive({
  open: false,
  current: 0,
});

const filters = reactive({
  year: "",
  question_type: "",
  knowledge_keyword: "",
  is_reviewed: undefined as string | undefined,
});

const pagination = reactive({ page: 1, size: 5, total: 0 });
const getTestPaperFileUrl = (path: string) => `/api/tp/file?path=${encodeURIComponent(path || "")}`;
const reviewStatusOptions: Option[] = [
  { label: "未复习", value: "false" },
  { label: "已复习", value: "true" },
];

const text = (value: unknown) => String(value ?? "").trim();
const filterOption = (input: string, option: any) => text(option?.label).toLowerCase().includes(input.toLowerCase());
const analysisViewerTitle = computed(() => {
  const record = analysisViewer.record;
  const question = text(record?.string_number || record?.question_key || "-");
  return `${question} 题解析`;
});
const questionPreviewImages = computed(() => (questionPreview.record ? questionImagePaths(questionPreview.record).map(displayImageUrl).filter(Boolean) : []));
const analysisPreviewImages = computed(() => (analysisViewer.record ? extractImageUrls(analysisContent(analysisViewer.record)).map(displayImageUrl).filter(Boolean) : []));
const buildParams = () => ({
  page: pagination.page,
  size: pagination.size,
  year: text(filters.year) || undefined,
  question_type: text(filters.question_type) || undefined,
  knowledge_keyword: text(filters.knowledge_keyword) || undefined,
  is_reviewed: filters.is_reviewed,
});

const search = async (resetPage = false) => {
  if (!studentUid.value) {
    message.warning("未识别学生身份");
    return;
  }
  if (resetPage) pagination.page = 1;
  loading.value = true;
  try {
    const res = await searchStudentWrongQuestionApi({ student_uid: studentUid.value, ...buildParams() });
    if (Number(res?.code) !== 200) throw new Error(res?.msg || "查询失败");
    rows.value = Array.isArray(res?.data) ? res.data : [];
    pagination.total = Number(res?.total || rows.value.length || 0);
    preloadRecordImages(rows.value);
  } catch (error: any) {
    rows.value = [];
    pagination.total = 0;
    message.error(error?.message || "查询错题失败");
  } finally {
    loading.value = false;
  }
};

const loadRecommend = async () => {
  if (!studentUid.value) return;
  recommendLoading.value = true;
  try {
    const res = await getStudentWrongQuestionRecommendApi({
      student_uid: studentUid.value,
      ...buildParams(),
      limit: 12,
    });
    if (Number(res?.code) !== 200) throw new Error(res?.msg || "推荐失败");
    recommendKnowledge.value = Array.isArray(res?.data?.knowledge_points) ? res.data.knowledge_points : [];
    recommendTypes.value = Array.isArray(res?.data?.question_types) ? res.data.question_types : [];
    questionTypeOptions.value = recommendTypes.value.map((item) => ({ label: item.name, value: item.name }));
  } catch (error: any) {
    message.error(error?.message || "推荐加载失败");
  } finally {
    recommendLoading.value = false;
  }
};

const handleSearch = () => search(true);
const handlePageChange = async (page: number) => {
  pagination.page = page;
  await search(false);
};
const handleSizeChange = async (_page: number, size: number) => {
  pagination.size = size;
  await search(true);
};
const resetFilters = () => {
  filters.year = "";
  filters.question_type = "";
  filters.knowledge_keyword = "";
  filters.is_reviewed = undefined;
  recommendKnowledge.value = [];
  recommendTypes.value = [];
  search(true);
};
const useKnowledge = async (name: string) => {
  filters.knowledge_keyword = name;
  await search(true);
};
const useType = async (name: string) => {
  filters.question_type = name;
  await search(true);
};
const openQuestionViewer = async (record: WrongQuestionRecord) => {
  questionPreview.record = record;
  questionPreview.current = 0;
  await nextTick();
  questionPreview.open = true;
};
const openAnalysisViewer = (record: WrongQuestionRecord) => {
  analysisViewer.record = record;
  analysisViewer.open = true;
};
const handleQuestionPreviewVisibleChange = (visible: boolean) => {
  questionPreview.open = visible;
};
const handleAnalysisPreviewVisibleChange = (visible: boolean) => {
  analysisPreview.open = visible;
};
const openAnalysisImagePreview = async (src: string) => {
  const index = analysisPreviewImages.value.findIndex((item) => item === src);
  if (index < 0) return;
  analysisPreview.current = index;
  await nextTick();
  analysisPreview.open = true;
};
const handleAnalysisImageClick = (event: MouseEvent) => {
  const target = event.target;
  if (!(target instanceof HTMLImageElement) || !target.classList.contains("markdown-image")) return;
  openAnalysisImagePreview(target.dataset.previewSrc || target.currentSrc || target.src);
};

const protectedImageUrls = reactive<Record<string, string>>({});
const loadingImageUrls = new Set<string>();
const failedImageUrls = new Set<string>();

const stringList = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.map(text).filter(Boolean);
  const raw = text(value);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.map(text).filter(Boolean);
  } catch {}
  return [raw];
};

const imageFieldList = (value: unknown): string[] => {
  if (Array.isArray(value)) return value.flatMap(imageFieldList);
  if (value && typeof value === "object") {
    const item = value as Record<string, unknown>;
    return imageFieldList(
      item.url ??
        item.src ??
        item.path ??
        item.file_path ??
        item.filePath ??
        item.image_url ??
        item.imageUrl ??
        item.file_url ??
        item.fileUrl
    );
  }

  const raw = text(value).replace(/^['"<]+|['">]+$/g, "");
  if (!raw) return [];
  try {
    return imageFieldList(JSON.parse(raw));
  } catch {}

  if (/^(https?:)?\/\//i.test(raw) || raw.startsWith("data:") || raw.startsWith("blob:") || raw.startsWith("/api/tp/file")) {
    return [raw];
  }

  return raw
    .split(/[,，;\n\r]+/)
    .map((item) => item.trim().replace(/^['"<]+|['">]+$/g, ""))
    .filter(Boolean);
};

const uniqueList = (values: string[]) => Array.from(new Set(values.map(text).filter(Boolean)));

const questionImagePaths = (record: WrongQuestionRecord) =>
  uniqueList(
    [
      record.images,
      record.question_images,
      record.questionImages,
      record.image_urls,
      record.imageUrls,
      record.question_image_urls,
      record.questionImageUrls,
      record.image,
      record.question_image,
      record.image_path,
      record.question_image_path,
    ].flatMap(imageFieldList)
  );

const analysisContent = (record?: WrongQuestionRecord | null) =>
  text(
    record?.analysis ??
      record?.answer_analysis ??
      record?.answerAnalysis ??
      record?.analysis_content ??
      record?.analysisContent ??
      record?.explanation ??
      ""
  );

const fileRequestUrl = (path: unknown) => {
  const value = text(path);
  if (!value) return "";
  if (/^(https?:)?\/\//i.test(value) || value.startsWith("data:") || value.startsWith("blob:")) return value;
  if (value.startsWith("/api/tp/file")) return value;
  return getTestPaperFileUrl(value);
};

const isProtectedFileUrl = (url: string) => url.startsWith("/api/tp/file");

const fetchProtectedImageUrl = async (requestUrl: string) => {
  if (!requestUrl || protectedImageUrls[requestUrl] || loadingImageUrls.has(requestUrl) || failedImageUrls.has(requestUrl)) return;
  loadingImageUrls.add(requestUrl);
  try {
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    const response = await fetch(requestUrl, { headers, credentials: "include" });
    if (!response.ok) throw new Error(`图片加载失败：${response.status}`);
    const blob = await response.blob();
    protectedImageUrls[requestUrl] = URL.createObjectURL(blob);
  } catch {
    failedImageUrls.add(requestUrl);
  } finally {
    loadingImageUrls.delete(requestUrl);
  }
};

const displayImageUrl = (path: unknown) => {
  const requestUrl = fileRequestUrl(path);
  if (!requestUrl) return "";
  if (!isProtectedFileUrl(requestUrl)) return requestUrl;
  if (failedImageUrls.has(requestUrl)) return "";
  if (!protectedImageUrls[requestUrl]) fetchProtectedImageUrl(requestUrl);
  return protectedImageUrls[requestUrl] || transparentImage;
};
const formatScore = (value: unknown) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return Number.isInteger(num) ? String(num) : num.toFixed(2);
};
const escapeHtml = (value: string) =>
  value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
const createMarkdownImagePattern = () => /!\[([^\]]*)\]\(\s*(?:<([^>]+)>|"([^"]+)"|'([^']+)'|([^)]+?))\s*(?:\s+["'][^"']*["'])?\)/g;
const markdownImagePaths = (value: unknown) => {
  const urls: string[] = [];
  let match: RegExpExecArray | null;
  const pattern = createMarkdownImagePattern();
  while ((match = pattern.exec(text(value))) !== null) {
    const src = text(match[2] ?? match[3] ?? match[4] ?? match[5]);
    if (src) urls.push(src);
  }
  const htmlPattern = /<img\b[^>]*\bsrc=(?:"([^"]+)"|'([^']+)'|([^\s>]+))/gi;
  while ((match = htmlPattern.exec(text(value))) !== null) {
    const src = text(match[1] ?? match[2] ?? match[3]);
    if (src) urls.push(src);
  }
  return uniqueList(urls);
};
const renderMarkdownLine = (line: string) => {
  const imagePattern = createMarkdownImagePattern();
  let cursor = 0;
  let html = "";
  let match: RegExpExecArray | null;

  while ((match = imagePattern.exec(line)) !== null) {
    html += escapeHtml(line.slice(cursor, match.index));
    const src = displayImageUrl(match[2] ?? match[3] ?? match[4] ?? match[5]);
    if (src) {
      html += `<img class="markdown-image" src="${escapeHtml(src)}" data-preview-src="${escapeHtml(src)}" alt="${escapeHtml(match[1] || "answer image")}" loading="lazy" decoding="async" />`;
    }
    cursor = match.index + match[0].length;
  }

  html += escapeHtml(line.slice(cursor));
  return `<p>${html}</p>`;
};
const renderMarkdown = (value: unknown) => text(value).split(/\r?\n/).map(renderMarkdownLine).join("");

// 从解析文本中提取出图片URL
const extractImageUrls = (value: unknown): string[] => {
  return markdownImagePaths(value);
};

// 从解析文本中提取纯文本部分（不含图片标记）
const extractAnalysisText = (value: unknown): string => {
  const raw = text(value);
  if (!raw) return "";
  return raw.replace(/!\[[^\]]*\]\([^)\s]+(?:\s+["'][^"']*["'])?\)/g, "").trim();
};
const preloadRecordImages = (records: WrongQuestionRecord[]) => {
  for (const record of records) {
    for (const path of [...questionImagePaths(record), ...extractImageUrls(analysisContent(record)), ...extractImageUrls(record.answer)]) {
      const requestUrl = fileRequestUrl(path);
      if (isProtectedFileUrl(requestUrl)) fetchProtectedImageUrl(requestUrl);
    }
  }
};

onBeforeUnmount(() => {
  for (const url of Object.values(protectedImageUrls)) {
    if (url) URL.revokeObjectURL(url);
  }
});
const recordKey = (record: WrongQuestionRecord) =>
  [record.exam_id, record.test_paper_id, record.question_key || record.string_number].map(text).join("-");

// ===== 购物车选择相关 =====

const selectAllQuestions = computed({
  get: () => rows.value.length > 0 && selectedQuestionKeys.value.size === rows.value.length,
  set: () => {},
});

const handleSelectAllQuestions = () => {
  if (selectedQuestionKeys.value.size === rows.value.length) {
    selectedQuestionKeys.value = new Set();
  } else {
    selectedQuestionKeys.value = new Set(rows.value.map((r) => recordKey(r)));
  }
};

const toggleQuestionSelection = (record: WrongQuestionRecord) => {
  const key = recordKey(record);
  const next = new Set(selectedQuestionKeys.value);
  if (next.has(key)) {
    next.delete(key);
  } else {
    next.add(key);
  }
  selectedQuestionKeys.value = next;
};

/** 将选中的错题添加到购物车 */
const handleAddToCart = async () => {
  if (!selectedQuestionKeys.value.size) {
    message.warning("请先勾选要加入购物车的题目");
    return;
  }
  addingToCart.value = true;
  let added = 0;
  const keys = Array.from(selectedQuestionKeys.value);
  try {
    for (const key of keys) {
      const record = rows.value.find((r) => recordKey(r) === key);
      if (!record) continue;
      try {
        const res = await postCartList({
          student_id: studentUid.value,
          test_question_id: String(record.question_id || record.question_key || record.string_number || ""),
          test_paper_id: String(record.test_paper_id || ""),
        });
        if (Number(res?.code) === 200) added++;
      } catch {
        // 跳过添加失败的，继续处理
      }
    }
    if (added > 0) {
      incrementCount(added);
      message.success(`成功添加 ${added} 道错题到购物车`);
      selectedQuestionKeys.value = new Set();
    } else {
      message.warning("添加失败，请稍后重试");
    }
  } catch {
    message.error("添加购物车出错");
  } finally {
    addingToCart.value = false;
  }
};

const handleGoToCart = () => {
  cartDrawerOpen.value = true;
};

const toggleReviewed = async (record: WrongQuestionRecord) => {
  if (!studentUid.value) return;
  const currentKey = recordKey(record);
  const questionKey = text(record.question_key || record.string_number);
  if (!record.test_paper_id || !questionKey) {
    message.warning("缺少试卷或题号信息");
    return;
  }

  reviewUpdatingKey.value = currentKey;
  try {
    const nextValue = !record.is_reviewed;
    // 生成类型 StudentWrongQuestionReview.test_paper_id 被错误定义为 Record<string, any>，实际后端接收 string
    const res = await putStudentWrongQuestionReview(
      { student_uid: studentUid.value },
      {
        test_paper_id: record.test_paper_id,
        question_key: questionKey,
        class_id: record.class_id,
        is_reviewed: nextValue,
      } as any
    );
    if (Number(res?.code) !== 200) throw new Error(res?.msg || "更新复习状态失败");
    record.is_reviewed = nextValue;
    if (filters.is_reviewed && filters.is_reviewed !== String(nextValue)) {
      rows.value = rows.value.filter((item) => recordKey(item) !== currentKey);
      pagination.total = Math.max(0, pagination.total - 1);
    }
    message.success(nextValue ? "已标记为已复习" : "已取消复习标记");
  } catch (error: any) {
    message.error(error?.message || "更新复习状态失败");
  } finally {
    reviewUpdatingKey.value = "";
  }
};

onMounted(async () => {
  const user = userStore.getUserInfo();
  if (user?.teacher) {
    message.warning("当前账号是老师，请使用老师端错题模块");
    router.replace("/wrong_question");
    return;
  }
  studentUid.value = text(user?.student?.uid || user?.role);
  studentName.value = text(user?.student?.name || user?.nickname || user?.username);
  await Promise.all([search(true), loadRecommend(), fetchCartCount(studentUid.value)]);
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", null, [
        _createElementVNode("h2", null, "我的错题"),
        _createElementVNode("p", null, "只展示当前账号的小题得分低于满分的题目。")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_badge, {
          count: _unref(cartCount),
          "overflow-count": 99,
          "show-zero": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { onClick: handleGoToCart }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("购物车", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(_component_a_button, {
          type: "primary",
          disabled: !selectedQuestionKeys.value.size,
          loading: addingToCart.value,
          onClick: handleAddToCart
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 加入购物车 (" + _toDisplayString(selectedQuestionKeys.value.size) + ") ", 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(studentName.value || studentUid.value || "学生"), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createVNode(_component_a_input, {
        value: filters.year,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((filters.year) = $event)),
        placeholder: "年份",
        "allow-clear": "",
        onPressEnter: handleSearch
      }, null, 8, ["value"]),
      _createVNode(_component_a_select, {
        value: filters.question_type,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((filters.question_type) = $event)),
        placeholder: "题型",
        options: questionTypeOptions.value,
        "allow-clear": "",
        "show-search": "",
        "filter-option": filterOption,
        onChange: handleSearch
      }, null, 8, ["value", "options"]),
      _createVNode(_component_a_input, {
        value: filters.knowledge_keyword,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((filters.knowledge_keyword) = $event)),
        placeholder: "关键词",
        "allow-clear": "",
        onPressEnter: handleSearch
      }, null, 8, ["value"]),
      _createVNode(_component_a_select, {
        value: filters.is_reviewed,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((filters.is_reviewed) = $event)),
        placeholder: "复习状态",
        options: reviewStatusOptions,
        "allow-clear": "",
        onChange: handleSearch
      }, null, 8, ["value"]),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: loading.value,
        onClick: handleSearch
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("查询", -1)
        ]))]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, {
        loading: recommendLoading.value,
        onClick: loadRecommend
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("推荐筛选", -1)
        ]))]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, { onClick: resetFilters }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
          _createTextVNode("重置", -1)
        ]))]),
        _: 1
      })
    ]),
    (recommendKnowledge.value.length || recommendTypes.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendKnowledge.value, (item) => {
            return (_openBlock(), _createBlock(_component_a_tag, {
              key: `k-${item.name}`,
              color: "processing",
              class: "click-tag",
              onClick: ($event: any) => (useKnowledge(item.name))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendTypes.value, (item) => {
            return (_openBlock(), _createBlock(_component_a_tag, {
              key: `t-${item.name}`,
              color: "blue",
              class: "click-tag",
              onClick: ($event: any) => (useType(item.name))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_a_checkbox, {
            checked: selectAllQuestions.value,
            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((selectAllQuestions).value = $event)),
            indeterminate: selectedQuestionKeys.value.size > 0 && selectedQuestionKeys.value.size < rows.value.length,
            onChange: handleSelectAllQuestions
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" 全选 ", -1)
            ]))]),
            _: 1
          }, 8, ["checked", "indeterminate"]),
          _cache[13] || (_cache[13] = _createElementVNode("h3", null, "错题列表", -1))
        ]),
        _createElementVNode("span", null, "共 " + _toDisplayString(pagination.total) + " 题", 1)
      ]),
      _createVNode(_component_a_spin, { spinning: loading.value }, {
        default: _withCtx(() => [
          (!rows.value.length)
            ? (_openBlock(), _createBlock(_component_a_empty, {
                key: 0,
                description: "暂无错题数据"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (record) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: recordKey(record),
                    class: "question-card"
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_checkbox, {
                        checked: selectedQuestionKeys.value.has(recordKey(record)),
                        class: "question-checkbox",
                        onChange: ($event: any) => (toggleQuestionSelection(record))
                      }, null, 8, ["checked", "onChange"]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("strong", null, _toDisplayString(record.string_number || record.question_key || "-") + " 题", 1),
                          (record.subject)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 0,
                                color: "blue"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(record.subject), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (record.question_type)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 1,
                                color: "gold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(record.question_type), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          (record.year)
                            ? (_openBlock(), _createBlock(_component_a_tag, {
                                key: 2,
                                color: "green"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(record.year), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_tag, {
                            color: record.is_reviewed ? 'green' : 'default'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.is_reviewed ? "已复习" : "未复习"), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", null, "我的得分 " + _toDisplayString(formatScore(record.student_score)) + "/" + _toDisplayString(formatScore(record.full_score)), 1),
                          (record.exam_name)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(record.exam_name), 1))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_button, {
                            size: "small",
                            type: record.is_reviewed ? 'default' : 'primary',
                            loading: reviewUpdatingKey.value === recordKey(record),
                            onClick: ($event: any) => (toggleReviewed(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(record.is_reviewed ? "标记未复习" : "确认已复习"), 1)
                            ]),
                            _: 2
                          }, 1032, ["type", "loading", "onClick"])
                        ])
                      ])
                    ]),
                    (stringList(record.knowledge_points).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stringList(record.knowledge_points), (point) => {
                            return (_openBlock(), _createBlock(_component_a_tag, {
                              key: point,
                              color: "geekblue"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(point), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _cache[15] || (_cache[15] = _createElementVNode("span", null, "题目图片", -1)),
                          (questionImagePaths(record).length)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "link",
                                size: "small",
                                onClick: ($event: any) => (openQuestionViewer(record))
                              }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode("放大", -1)
                                ]))]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        (questionImagePaths(record).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionImagePaths(record), (image, index) => {
                                return (_openBlock(), _createElementBlock("img", {
                                  key: `${recordKey(record)}-${index}`,
                                  src: displayImageUrl(image),
                                  class: "question-image",
                                  loading: "lazy",
                                  decoding: "async",
                                  alt: "question image",
                                  onClick: ($event: any) => (openQuestionViewer(record))
                                }, null, 8, _hoisted_21))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock(_component_a_empty, {
                              key: 1,
                              description: "暂无题图"
                            }))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "box-title" }, "解析", -1)),
                        (text(analysisContent(record)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (extractAnalysisText(analysisContent(record)))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(extractAnalysisText(analysisContent(record))), 1))
                                : _createCommentVNode("", true),
                              (extractImageUrls(analysisContent(record)).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extractImageUrls(analysisContent(record)), (url, index) => {
                                      return (_openBlock(), _createBlock(_component_a_image, {
                                        key: `analysis-${index}`,
                                        src: displayImageUrl(url),
                                        class: "question-image"
                                      }, null, 8, ["src"]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createBlock(_component_a_empty, {
                              key: 1,
                              description: "暂无解析"
                            }))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "box-title" }, "答案", -1)),
                      (text(record.answer))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "markdown-body",
                            innerHTML: renderMarkdown(record.answer)
                          }, null, 8, _hoisted_27))
                        : (_openBlock(), _createBlock(_component_a_empty, {
                            key: 1,
                            description: "暂无答案"
                          }))
                    ])
                  ]))
                }), 128))
              ]))
        ]),
        _: 1
      }, 8, ["spinning"]),
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_a_pagination, {
          current: pagination.page,
          "page-size": pagination.size,
          total: pagination.total,
          "show-size-changer": "",
          "show-total": (total) => `共 ${total} 条`,
          onChange: handlePageChange,
          onShowSizeChange: handleSizeChange
        }, null, 8, ["current", "page-size", "total", "show-total"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      open: analysisViewer.open,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((analysisViewer.open) = $event)),
      title: analysisViewerTitle.value,
      footer: null,
      width: 960,
      "wrap-class-name": "analysis-viewer-modal"
    }, {
      default: _withCtx(() => [
        (analysisViewer.record && text(analysisContent(analysisViewer.record)))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "markdown-body analysis-viewer-body",
              onClick: handleAnalysisImageClick,
              innerHTML: renderMarkdown(analysisContent(analysisViewer.record))
            }, null, 8, _hoisted_29))
          : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              description: "暂无解析"
            }))
      ]),
      _: 1
    }, 8, ["open", "title"]),
    _createElementVNode("div", _hoisted_30, [
      (questionPreviewImages.value.length)
        ? (_openBlock(), _createBlock(_component_a_image_preview_group, {
            key: 0,
            preview: { visible: questionPreview.open, current: questionPreview.current, onVisibleChange: handleQuestionPreviewVisibleChange }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionPreviewImages.value, (src, index) => {
                return (_openBlock(), _createBlock(_component_a_image, {
                  key: `question-preview-${index}-${src}`,
                  src: src
                }, null, 8, ["src"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["preview"]))
        : _createCommentVNode("", true),
      (analysisPreviewImages.value.length)
        ? (_openBlock(), _createBlock(_component_a_image_preview_group, {
            key: 1,
            preview: { visible: analysisPreview.open, current: analysisPreview.current, onVisibleChange: handleAnalysisPreviewVisibleChange }
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(analysisPreviewImages.value, (src, index) => {
                return (_openBlock(), _createBlock(_component_a_image, {
                  key: `analysis-preview-${index}-${src}`,
                  src: src
                }, null, 8, ["src"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["preview"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(WrongQuestionCartDrawer, {
      open: cartDrawerOpen.value,
      "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((cartDrawerOpen).value = $event)),
      "student-id": studentUid.value
    }, null, 8, ["open", "student-id"])
  ]))
}
}

})